import HttpRequest from "@api/httpRequest";
import {RequestData} from "@models/axios";

const getUrl = (): string => {
  return `/discount-codes`
};

function api() {
  return {
    getList: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(`${getUrl()}`, {
        params: params
      });
    },
    
    getItemStatistics: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(`${getUrl()}/${params.id}/statistics`, {
        params
      });
    },
    
    getItemUses: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(`${getUrl()}/${params.id}/uses`, {
        params
      });
    },
    
  };
}

export default api();
